import { fmt } from '../lib/format';
import { useBlockNumber } from '../hooks/useBlockNumber';
import { useWallet } from '../hooks/useWallet';

/**
 * Topbar live indicator — green LED + "SEPOLIA · #blockNumber".
 * Shows "wrong network" in amber if the wallet is on the wrong chain.
 */
export default function LiveBlock() {
  const { data: block, isLoading } = useBlockNumber();
  const wallet = useWallet();

  if (wallet.status === 'wrong-network') {
    return (
      <span className="live-led" style={{ color: 'var(--amber)' }}>
        <span className="led" style={{ background: 'var(--amber)', boxShadow: '0 0 10px var(--amber)' }} />
        WRONG NETWORK · CHAIN {wallet.chainId}
      </span>
    );
  }

  return (
    <span className="live-led" title={isLoading ? 'fetching head…' : `block ${block}`}>
      <span className="led" />
      SEPOLIA · #<b>{block ? fmt.blockNumber(block) : '—'}</b>
    </span>
  );
}
